angular.module("plafondRequest.components", []).component("plafondRequest", {
  templateUrl: "ng/components/plafondRequest/plafondRequest.html",
  controllerAs: "plafondRequestCtrl",
  bindings: {
    outputPlafond: "=",
    ndgCli: "<",
    gestioneFornitori: "=",
    updatePlafond: "&",
    vendorManagement: "="
  },
  controller: function ($financialApiService, $rootScope, $configService) {
    var self = this;

    self.$onInit = function () {
      if (self.gestioneFornitori && self.gestioneFornitori.plafond) {
        self.outputPlafond = self.gestioneFornitori.plafond
      }
      if(self.outputPlafond.status == 'IN ALLESTIMENTO') {
        self.outputPlafond.importoUtilizzo = 0;
      }
      self.isGaranteTerzo = 'false';
      self.isGestioneFornitorePlus = $configService.getAppConfig().allFunctionalities.includes("GESTIONE_FORNITORE_PLUS") ? true : false;
      self.isAgente = $configService.getAppConfig().user.type == 'VENDOR_AGENT' ? true : false;
    };

    self.handleChange = function (value, property) {
      if (property != "garanteTerzo") {
        self.outputPlafond[property] = value;
        self.gestioneFornitori.plafond = self.outputPlafond;
      } else if (property == "garanteTerzo") {
        self.isVisibleGaranteTerzo = value;
        self.outputPlafond.garanteTerzo = value;
        self.outputPlafond.ndgGarante = value == false ? null : self.outputPlafond.ndgGarante
      }
    };

    self.savePlafond = function () {
      self.outputPlafond.ndgCli = self.ndgCli;
      self.vendorManagement.isSavingPlafond = true;
      $financialApiService
        .insertPlafond(self.outputPlafond, self.gestioneFornitori.idOperation)
        .then(function (response) {
          if (response.success) {
            self.updatePlafond && self.updatePlafond();
            self.outputPlafond.dataConferma = response.dataConferma;
            self.outputPlafond.utente = response.utente;
            self.outputPlafond.verificato = response.verificato;
            self.outputPlafond.vrMassimo = response.vrMassimo;
          } else {
            self.vendorManagement.isSavingPlafond = false;
          }
        })
        .catch(function (err) {
          self.vendorManagement.isSavingPlafond = false;
          console.log(err);
        });
    };
  },
});
